window.$ = require("jquery");
window.jQuery = require("jquery");

require('datatables.net');

require("./app/blocks/main-nav");
require("./app/blocks/mail-list");

require("./app/blocks/overlay-terms-conditions");

require("./app/pages/race-subscribe-wizard");
require("./app/pages/circuit-subscribe-wizard");

require("./race-manager/race-order.js")

require("./components/comuni-autocomplete")

$(document).ready( () => {

	$(".print-icon").on("click tap", () => {
		window.print();
	});

	// Initialize DataTable only if table exists and is not already initialized
	var team_members_table = null;
	if ($('#team-members').length > 0) {
		// Check if already initialized
		if ($.fn.DataTable.isDataTable('#team-members')) {
			// Already initialized, get existing instance
			team_members_table = $('#team-members').DataTable();
		} else {
			// Initialize new DataTable
			team_members_table = $('#team-members').DataTable({
				paging: false,
				ordering: false,
				info: false,
				dom: 't'
			});
		}
	}

	/*
	* Search
	*/
	$('#search_team_member').on('input', function() {
		var searchValue = $(this).val();

		// Show table when user starts typing, hide when empty
		if (searchValue.length > 0) {
			$('.team-members-wrapper').fadeIn(200);
		} else {
			$('.team-members-wrapper').fadeOut(200);
		}

		// Perform search only if DataTable exists
		if (team_members_table) {
			team_members_table.search(searchValue).draw();
		}
	});

	/*
	 * Get team members data buttons
	 */
	document.querySelectorAll('.team-members tbody tr').forEach( ($row) => {
		$row.addEventListener( 'click', (e) => {
				e.preventDefault()
				document.location = '?autofill-contact-id=' + $row.dataset.contact_id
			})
	})

	/*
	 * Address book modal
	 */
	var addressBookModal = document.getElementById('address-book-modal');
	var openAddressBookModalBtn = document.getElementById('open-address-book-modal');
	var modalSearchInput = document.getElementById('modal-search-contact');

	if (addressBookModal && openAddressBookModalBtn) {
		var modalClose = addressBookModal.querySelector('.address-book-modal__close');
		var modalBackdrop = addressBookModal.querySelector('.address-book-modal__backdrop');
		var modalItems = addressBookModal.querySelectorAll('.address-book-modal__item');
		var modalNoResults = addressBookModal.querySelector('.address-book-modal__no-results');

		function openAddressBookModal() {
			addressBookModal.style.display = 'flex';
			if (modalSearchInput) {
				modalSearchInput.value = '';
				modalSearchInput.focus();
				// Show all items, hide no-results
				modalItems.forEach(function(item) { item.style.display = ''; });
				if (modalNoResults) modalNoResults.style.display = 'none';
			}
		}

		function closeAddressBookModal() {
			addressBookModal.style.display = 'none';
		}

		openAddressBookModalBtn.addEventListener('click', openAddressBookModal);
		if (modalClose) modalClose.addEventListener('click', closeAddressBookModal);
		if (modalBackdrop) modalBackdrop.addEventListener('click', closeAddressBookModal);

		document.addEventListener('keydown', function(e) {
			if (e.key === 'Escape' && addressBookModal.style.display !== 'none') {
				closeAddressBookModal();
			}
		});

		// Live search filter
		if (modalSearchInput) {
			modalSearchInput.addEventListener('input', function() {
				var query = this.value.toLowerCase().trim();
				var visibleCount = 0;
				modalItems.forEach(function(item) {
					var matches = !query || (item.dataset.search && item.dataset.search.includes(query));
					item.style.display = matches ? '' : 'none';
					if (matches) visibleCount++;
				});
				if (modalNoResults) {
					modalNoResults.style.display = (visibleCount === 0 && modalItems.length > 0) ? '' : 'none';
				}
			});
		}

		// Click on contact item → redirect
		modalItems.forEach(function(item) {
			item.addEventListener('click', function() {
				document.location = '?autofill-contact-id=' + this.dataset.contact_id;
			});
			item.addEventListener('keydown', function(e) {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					document.location = '?autofill-contact-id=' + this.dataset.contact_id;
				}
			});
		});
	}

});
